// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {InventoryAgeingRecord} from './api'

const getInventoryAgeingColumns = (): ReadonlyArray<Column<InventoryAgeingRecord>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Product'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'productName',
    accessor: 'productName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='SKU Code' className='min-w-100px text-center' />
    ),
    accessor: 'skuCode',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='0-30 Days' className='min-w-100px text-center' />
    ),
    accessor: 'd0To30',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='31-60 Days' className='min-w-100px text-center' />
    ),
    accessor: 'd31To60',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='61-90 Days' className='min-w-100px text-center' />
    ),
    accessor: 'd61To90',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='90+ Days' className='min-w-100px text-center' />
    ),
    accessor: 'd90Plus',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='text-danger fw-bold'>{props.data[props.row.index].d90Plus}</span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='UOM' className='min-w-70px text-center' />
    ),
    accessor: 'unit',
    sortType: 'string',
    Cell: ({...props}) => (
      <span className='badge badge-light-dark fw-bold'>{props.data[props.row.index].unit}</span>
    ),
  },
]

export {getInventoryAgeingColumns}
